import Table from 'react-bootstrap/Table';
import { useNavigate, useLocation } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import { FaSortDown, FaSortUp } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

import { GTMsendEvent } from '../../../utils/trackingGA4'

const VehicleTable = ({
	getTableProps,
	headerGroups,
	getTableBodyProps,
	page,
	prepareRow,
	resultCount,
	handleDoubleClick,
	viewLimitMessage
}) => {
	const navigate = useNavigate();
	const location = useLocation();
	const currentURL = location.pathname;
	const { t } = useTranslation()

	return (
		<>
			<div className="table-results-container">
				{t('show')}:{' '}
				<span className="table-result-count">{resultCount}</span>
				{viewLimitMessage
					? (
						<span className="mx-2 table-view-limit">
							{viewLimitMessage}
						</span>
					) : null}
			</div>
			<Card>
				<div className='flipped-container flipped'>
					<Table
						striped
						borderless
						hover
						responsive
						{...getTableProps()}
						className="vehicle-table m-0"
					>
						<thead className="border-bottom">
							{headerGroups.map((headerGroup) => (
								<tr {...headerGroup.getHeaderGroupProps()}>
									{headerGroup.headers.map((column: any) => (
										<th
											className="text-nowrap"
											{...column.getHeaderProps({
												...column.getSortByToggleProps({ title: undefined }),
												className: column.className,
											})}
										>
											{column.render('Header')}
											{column.canSort ? (
												<span className="position-relative">
													{column.isSorted ? (
														column.isSortedDesc ? (
															<>
																<FaSortUp className="mt-1 opacity-25 position-absolute" />
																<FaSortDown className="mt-1 position-absolute" />
															</>
														) : (
															<>
																<FaSortUp className="mt-1 position-absolute" />
																<FaSortDown className="mt-1 opacity-25 position-absolute" />
															</>
														)
													) : (
														<>
															<FaSortUp className="mt-1 opacity-25 position-absolute" />
															<FaSortDown className="mt-1 opacity-25 position-absolute" />
														</>
													)}
												</span>
											) : null}
										</th>
									))}
								</tr>
							))}
						</thead>
						<tbody {...getTableBodyProps()}>
							{page.map((row, i) => {
								prepareRow(row);
								return (
									<tr
										{...row.getRowProps()}
										onDoubleClick={() => handleDoubleClick?.(row)}

									// onDoubleClick={() => {
									// 	if(!currentURL.includes("opportunities") && !currentURL.includes("details")) {
									// 		navigate(`/details/${row.original.id}`)
									// 	} else {
									// 		handleDetailsPudModal(row.original)
									// 	}
									// 	let position = ''
									// 	if (currentURL === '/available-vehicles') {
									// 		position = 'lista veicoli'
									// 	} else if (currentURL === '/my-stock') {
									// 		position = 'my stock'
									// 	}
									// }}
									>
										{row.cells.map((cell: any) => {
											return (
												<td
													{...cell.getCellProps({
														className: cell.column.className,
													})}
												>

													{cell.render('Cell')}
												</td>
											)
										})}
									</tr>
								);
							})}
						</tbody>
					</Table>
				</div>
			</Card>
		</>
	);
};

export default VehicleTable;
